import styled from 'styled-components';

const FontSize14Div = styled.div`
  font-size: 14px;
`;

export default FontSize14Div;
